import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const Form = styled.div`
  max-width: 564px;
  width: 100%;
`

export const BoxImage = styled.div`
  @media (min-width: 1024px) {
    padding-left: 90px;
  }
`

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`

export const Footer = styled.div``

export const Hr = styled.hr`
  height: 1px;
  margin-top: 10px;
  margin-bottom: 30px;
  border: none;
  background: rgba(0, 0, 0, 0.12);
`
